
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Style from "./Reward.module.scss";
import PerfectButtonIconLeft from "../../../assets/svg/PerfectButtonIconLeft";
import PerfectButtonIconRight from "../../../assets/svg/PerfectButtonIconRight";
import QuizWallicon from "../../../assets/svg/QuizWallicon";
import RewardCard from "../../../comman/card/RewardCard";
import axios from "../../../config/authAxios";
import authAxios from "../../../config/authAxios";
import { useSelector } from "react-redux";

export default function RewardHome() {

	const [goal, setGoal] = useState();
	const navigate = useNavigate();

	const handleClick = async () => {
		try {
			const response = await axios.put('/users/api/update/goal', { goal: goal })
			navigate('/home-challenge')
		} catch (error) {
			console.error("Error updating avatar:", error);
		}
	}

	const getAppSelector = useSelector(state => state.getApp)
	const { Config } = getAppSelector
	const [giftCard, setGiftCard] = useState([])
	const fetchCards = async (e) => {
		try {
			const response = await authAxios.get(`/users/api/giftCards/3`);
			if (response?.data?.data?.length == 0) {
				navigate('/home-challenge')
				return
			}
			setGiftCard([...response?.data?.data])
			setGoal(response?.data?.data[0]?.sku)
		} catch (error) {
			navigate('/home-challenge')
			console.error(error);
		}
	}
	useEffect(() => {
		fetchCards()
	}, [])
	return (
		<>
			<div className={Style.reward_container}>
				<div className={Style.reward_box1}><QuizWallicon width={162} height={36} /></div>
				<div className={Style.reward_bottm_box}>
					<div className={Style.reward_box4}><p className={Style.reward_text1}>Select Your Goal</p></div>
					<div className={Style.reward_box5}>
						{giftCard?.length > 0 && giftCard?.map((e) => {
							return (<React.Fragment key={e.id}>
								<div onClick={() => setGoal(e.sku)} className={Style.rewardCover}>
									{goal == e.sku && <div className={Style.avatar_tick}><img src={"https://d1qj6ph0z4cul6.cloudfront.net/live/pr_f_avatar-tick_1761338897543.png"} className={Style.tick_image} alt="tick-image" /></div>}
									<RewardCard data={e} rupVal={Config?.rup_val} isActive={goal == e.sku} />
								</div>
							</React.Fragment>)
						})}

					</div>
					<div className={Style.reward_box3} onClick={handleClick}>
						<PerfectButtonIconRight /><p className={Style.reward_button_box} >Continue</p><PerfectButtonIconLeft />
					</div>
				</div>

			</div>
		</>
	);
}
